import { useMemo } from 'react';
import { enableSupportedWarehouseExperimentationManifests } from '@gonfalon/dogfood-flags/dogfood-flags';
import { getIntegrationManifestQuery } from '@gonfalon/rest-api/queries/integrationManifests';
import { useQueries } from '@tanstack/react-query';

export const useWarehouseManifests = () => {
  // The flag defaults to [], but guard against a null value from LaunchDarkly so
  // building the manifest queries below can't throw and crash the create-metric modal.
  const warehouseExpManifestKeys = enableSupportedWarehouseExperimentationManifests() ?? [];
  const queries = useQueries({
    queries: warehouseExpManifestKeys.map((integrationKey) => getIntegrationManifestQuery({ integrationKey })),
  });
  return useMemo(() => queries.map((q) => q.data), [queries]);
};
